module.exports = __webpack_public_path__ + "img/center front length from high waist to hem.02763b77.png";